import React from "react";

export const AppLoader = ({ size = 100 }) => {
  return (
    <div className="app-loader page h-[100dvh] w-full flex justify-center items-center fixed top-0 left-0 z-[1051] bg-body">
      <div className="w-16 h-16 border-4 border-primary-400 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};
